const CastTable = ({
  cast,
  editNonFamousPerformer,
  deleteNonFamousPerformer,
  addToFamousPerformers,
}) => {
  if (!cast || cast.length === 0) return null;

  return (
    <table className="w-full border-collapse mt-4">
      <thead>
        <tr>
          <th className="p-2 text-white border border-[#444] bg-[#222] text-left">
            Name
          </th>
          <th className="p-2 text-white border border-[#444] bg-[#222] text-left">
            Role
          </th>
          <th className="p-2 text-white border border-[#444] bg-[#222] text-left">
            Date
          </th>
          <th className="p-2 text-white border border-[#444] bg-[#222] text-left">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        {cast.map((performer, index) => (
          <tr key={index}>
            <td className="p-2 text-white border border-[#444]">
              {performer.name}
            </td>
            <td className="p-2 text-white border border-[#444]">
              {performer.role}
            </td>
            <td className="p-2 text-white border border-[#444]">
              {performer?.date}
            </td>
            <td className="p-2 text-white border border-[#444] flex flex-row gap-2">
              <button
                type="button"
                onClick={() => editNonFamousPerformer(index)}
                className="px-3 py-1 bg-[#4CAF50] hover:bg-[#45a049] text-white text-sm rounded-md transition-colors"
              >
                Edit
              </button>
              <button
                type="button"
                onClick={() => deleteNonFamousPerformer(index)}
                className="px-3 py-1 bg-[#f44336] hover:bg-[#da190b] text-white text-sm rounded-md transition-colors"
              >
                Delete
              </button>
              {performer.famousPerformer === undefined && (
                <button
                  type="button"
                  onClick={() => addToFamousPerformers(performer)}
                  className="px-3 py-1 bg-[#d4a017] hover:bg-[#b38b00] text-white text-sm rounded-md transition-colors"
                >
                  Add to Famous
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CastTable;